import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '../services/auth.service';

const Logout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            try {
                await AuthService.logout();
            } finally {
                if (window.Intercom) {
                    window.Intercom('shutdown'); // This shuts down the Intercom widget
                }
                setTimeout(() => {
                    navigate('/login');
                }, 2000);
            }
        })();
    }, [navigate]);

    return (
        <Box 
            sx={{
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                background: "linear-gradient(105deg, #F6F2F7 -1.91%, #FEF1F2 47.85%, #F7F3E3 80.75%)",
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 9999
            }}
        >
            <CircularProgress size={40} sx={{ mb: 2 }} />
            <Typography variant="h6" color="#060023">
                Logging out...
            </Typography>
        </Box>
    );
};

export default Logout;
